export default __webpack_public_path__ + "static/media/comfort.89712c53.svg";